import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'

const DATA_ATTRIBUTES = {
    pagination: 'data-embla-pagination',
    paginationItem: 'data-embla-pagination-item',
    sliderContainer: 'data-embla-container',
};


const initSlider = function(emblaContainer){
    const options = JSON.parse(emblaContainer.dataset.emblaContainer)
    const plugins = [];
    if(options && options.hasOwnProperty('autoplay')){
        plugins.push(Autoplay( options.autoplay ))
    }

    const embla = EmblaCarousel(emblaContainer.querySelector("[data-embla-slider]"), options, plugins);

    embla.on('select',  (event)  => {
        setActiveSlide(embla);
    })

    return {slider : embla, sliderContainer: emblaContainer};
}
const sliderNavigation = function(embla, container){

    const navigation = container.querySelector('[data-embla-navigation]');
    if(navigation){
        navigation.addEventListener('click', (event) => {
            let navigationArrow = event.target;
            if (!navigationArrow.hasAttribute("data-embla-navigation-arrow")) {
                navigationArrow = navigationArrow.closest("[data-embla-navigation-arrow]");
            }
            navigationArrow.dataset.emblaNavigationArrow === 'prev' ? embla.scrollPrev() : embla.scrollNext();
        });
    }
}
const sliderPagination = function(embla, container){
    const pagination = container.querySelector('[data-embla-pagination]');
    if(pagination){
        pagination.addEventListener('click', (event) => {
            let paginationItem = event.target;
            if (!paginationItem.hasAttribute("data-embla-pagination-item")) {
                paginationItem = paginationItem.closest("[data-embla-pagination-item]");
            }
            setPaginationItem(embla, paginationItem.dataset.emblaPaginationItem);
        });

        embla.on('select',  (event)  => {
            setPaginationItem(embla, embla.selectedScrollSnap());
        })
    }
}

const setActiveSlide = function(embla){
    [...embla.slideNodes()].forEach((slide, index) => {
        if(Number.parseInt(index) === Number.parseInt(embla.selectedScrollSnap())){
            slide.classList.add('-active-slide')
        }else{
            slide.classList.remove('-active-slide')
        }
    });
}
const setPaginationItem = function(embla, index){
    const pagination = embla.rootNode().closest('[data-embla-container]').querySelector('[' + DATA_ATTRIBUTES.pagination +']');
    if(!pagination){
        return false;
    }

    const paginationOptions = JSON.parse(pagination.dataset.emblaPagination  || '{}');


    pagination.querySelectorAll('[' + DATA_ATTRIBUTES.paginationItem +']').forEach((node) => {
        node.classList.remove('-active')
    });

    if(paginationOptions.hasOwnProperty('selectMultiple')){
        pagination.querySelectorAll("[" + DATA_ATTRIBUTES.paginationItem + "]").forEach((node) => {
            if(Number.parseInt(node.dataset.emblaPaginationItem) <= index ){
                node.classList.add('-active')
            }
        });
    }else{
        pagination.querySelector("[" + DATA_ATTRIBUTES.paginationItem + "='" + index +"']").classList.add('-active');
    }

    embla.scrollTo(index);
};


export {initSlider, sliderNavigation, sliderPagination, setActiveSlide};